import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Step from '@material-ui/core/Step';
import StepConnector from '@material-ui/core/StepConnector';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import DoneIcon from '@material-ui/icons/Done';
import { skipToken } from '@reduxjs/toolkit/query';
import clsx from 'clsx';
import { isNil } from 'lodash';
import { useReducer, useEffect, useState, useRef, useCallback, useMemo, useContext, } from 'react';
import { useCookies } from 'react-cookie';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { WIZARD_STEP, QUERY_KEY, API_ERROR_MAP, CREDIT_PORTAL_URL, PATH, Spinner, P, reportError, scrollToTop, parseQuery, makeQueryPath, AnalyticsContext, INLINE_COLORS, } from 'shared';
import { useGetConsumerApplicationsV1CreditApplicationsTokenTokenValidateQuery, useGetConsumerApplicationsV1PrequalificationsNewQuery, useGetConsumerApplicationsV1LinkOtlTokenValidateQuery, } from 'consumer-applications-v1-api';
import { toastError } from 'utils';
import { setApplicationEnvironment as setApplicationEnvironmentApplicants, setPersonalInfo, setPractice, } from '../../applicants/actions';
import { clearApplicationEnvironment, setApplicationEnvironment as setApplicationEnvironmentCreditApp, setCreditApplication, setLenderName, } from '../actions';
import { selectors } from '../reducer';
import * as CreditApplicationWizard from '../wizard_views';
function Wizard({}) {
    const FormConnector = withStyles({
        alternativeLabel: {
            top: 10,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
        active: {
            '& $line': {
                borderColor: INLINE_COLORS.purpleBase,
            },
        },
        completed: {
            '& $line': {
                borderColor: INLINE_COLORS.purpleBase,
            },
        },
        line: {
            borderColor: INLINE_COLORS.greyLight,
            borderTopWidth: 3,
            borderRadius: 1,
        },
    })(StepConnector);
    const init = (initialStep) => {
        return { step: initialStep };
    };
    const reducer = (state, action) => {
        switch (action.type) {
            case 'next':
                if (state.step < WIZARD_STEP.APPROVAL) {
                    return { step: state.step + 1 };
                }
                else {
                    return { step: WIZARD_STEP.APPROVAL };
                }
            case 'prev':
                if (state.step > WIZARD_STEP.COLLECT_PERSONAL_INFO) {
                    return { step: state.step - 1 };
                }
                else {
                    return { step: WIZARD_STEP.COLLECT_PERSONAL_INFO };
                }
            case 'reset':
                return init(action.payload ? action.payload : 0);
            default:
                throw new Error();
        }
    };
    const getToken = () => {
        const query = parseQuery(location.search);
        const token = query[QUERY_KEY.TOKEN];
        return token;
    };
    //CUSTOM HOOKS
    const location = useLocation();
    const dispatch = useDispatch();
    const [cookies] = useCookies(['storeLinkCampaign']);
    const history = useHistory();
    const { analytics } = useContext(AnalyticsContext);
    //REDUX State
    const applicationEnvironment = useSelector(selectors.applicationEnvironment);
    const practice = useSelector(selectors.practice);
    const prequalification = useSelector(selectors.prequalification);
    const personalInfo = useSelector(selectors.personalInfo);
    //COMPONENT STATE
    const [payload, setPayload] = useState(null);
    const [applicationId, setApplicationId] = useState(null);
    const [locationId, setLocationId] = useState(null);
    const [state, dispatchLocal] = useReducer(reducer, 0, init);
    const tokenRef = useRef(getToken());
    //API HOOKS
    const { data: creditApplicationByTokenValidate, isLoading: isFetchingOTAToken, error: errorFetchingCreditApp, } = useGetConsumerApplicationsV1CreditApplicationsTokenTokenValidateQuery(tokenRef.current
        ? {
            token: tokenRef.current,
        }
        : skipToken);
    const { data: creditPreApplication, isLoading: isLoadingPrequalNew } = useGetConsumerApplicationsV1PrequalificationsNewQuery(locationId !== null
        ? {
            locationId,
            termsLanguage: 'en',
        }
        : skipToken);
    const { data: storeLinkCampaignMatches, isLoading: isFetchingCampaignValidation, } = useGetConsumerApplicationsV1LinkOtlTokenValidateQuery(cookies.storeLinkCampaign &&
        ((practice !== null && practice !== undefined) ||
            cookies.storeLinkCampaign.storeId === 'all') &&
        tokenRef.current === undefined
        ? {
            token: cookies.storeLinkCampaign.otl,
            storeLinkCampaign: cookies.storeLinkCampaign.campaignId,
            locationId: practice?.locationId,
            storeId: practice && practice.adsStoreNumber
                ? practice.adsStoreNumber.toString()
                : 'all',
        }
        : skipToken, {
        // Return previous data when an error occurs
        selectFromResult: (result) => ({
            ...result,
            data: result.isSuccess,
        }),
    });
    //MISC JS
    const prequalificationUrl = applicationEnvironment?.prequalificationUrl;
    const nativeApplicationEnabled = practice?.nativeApplicationEnabled === true;
    const steps = ['PERSONAL INFO', 'PRE-QUALIFICATION', 'APPROVAL'];
    const mobile_steps = [
        'TELL US ABOUT YOURSELF',
        'PRE-QUALIFICATION',
        'APPROVAL',
    ];
    const moveToNextStep = (data) => {
        dispatchLocal({ type: 'next' });
        scrollToTop();
        if (data) {
            setPayload(data);
        }
    };
    const completePrequalification = useCallback(() => {
        moveToNextStep();
    }, []);
    const getScreen = useMemo(() => {
        analytics?.track('WizardStep', {
            step: state.step,
        });
        switch (state.step) {
            case WIZARD_STEP.COLLECT_PERSONAL_INFO:
                return (_jsx(_Fragment, { children: _jsx(CreditApplicationWizard.PersonalInfoV2, { moveToNextStep: moveToNextStep, allowChangePractice: isNil(tokenRef.current), showFindApplication: isNil(tokenRef.current) }) }));
            case WIZARD_STEP.PERFORM_PREQUALIFICATION:
                return (_jsx(CreditApplicationWizard.PreQualification, { payload: payload, onStepComplete: completePrequalification, applicationEnvironment: applicationEnvironment }));
            case WIZARD_STEP.APPROVAL:
                return _jsx(CreditApplicationWizard.Approval, {});
            default:
                return _jsx(P, { children: "Page Not Found" });
        }
    }, [state.step, payload, applicationEnvironment, completePrequalification]);
    //EFFECTS
    useEffect(() => {
        const fromProve = sessionStorage.getItem('fromProve');
        const handleProveRouting = async () => {
            if (creditPreApplication &&
                !creditPreApplication.proveOptOut &&
                !fromProve &&
                !location.state?.fromFindMyApp) {
                const baseProvePath = `${PATH.CREDIT_PORTAL}${PATH.PROVE?.BASE}`;
                const existingQuery = parseQuery(location.search);
                // Add location id parameter if practice has adsStoreNumber
                if (practice?.locationId) {
                    existingQuery.location = practice.locationId;
                }
                if (practice?.adsStoreNumber) {
                    existingQuery.store = practice.adsStoreNumber;
                }
                const provePath = makeQueryPath(baseProvePath, existingQuery);
                history.push(provePath, { practice: practice });
            }
        };
        handleProveRouting();
        const selectedLocationId = practice?.locationId;
        setLocationId(selectedLocationId);
    }, [creditPreApplication]);
    useEffect(() => {
        if (creditPreApplication) {
            //Currently this is set in both reducers
            dispatch(setApplicationEnvironmentCreditApp(creditPreApplication));
            dispatch(setApplicationEnvironmentApplicants(creditPreApplication));
        }
        return () => {
            dispatch(clearApplicationEnvironment());
        };
    }, [creditPreApplication, dispatch]);
    useEffect(() => {
        scrollToTop();
        if (location.state?.step === 'PRE-QUALIFICATION') {
            dispatchLocal({ type: 'reset', payload: 1 });
        }
        else if (location.state?.step === 'APPROVAL') {
            dispatchLocal({ type: 'reset', payload: 2 });
        }
    }, [location.pathname, location.state?.step]);
    useEffect(() => {
        if (!isNil(prequalificationUrl) &&
            isNil(tokenRef.current) &&
            location.state?.fromFindMyApp !== true &&
            !isFetchingOTAToken &&
            !isLoadingPrequalNew &&
            !isFetchingCampaignValidation &&
            !storeLinkCampaignMatches &&
            !nativeApplicationEnabled) {
            window.location.href = prequalificationUrl;
        }
        else if (!isNil(tokenRef.current) && creditApplicationByTokenValidate) {
            // personalInfo / creditApplication are dispatched in the effect below;
            // this branch only handles applicationId + the prequalification redirect.
            if (creditApplicationByTokenValidate.creditApplication?.applicationId)
                setApplicationId(creditApplicationByTokenValidate.creditApplication.applicationId);
            if (isNil(creditApplicationByTokenValidate?.creditApplication?.applicationId) &&
                !isFetchingOTAToken &&
                !isNil(prequalificationUrl) &&
                !storeLinkCampaignMatches &&
                !isFetchingCampaignValidation &&
                !nativeApplicationEnabled) {
                window.location.href = prequalificationUrl;
            }
        }
        else if (errorFetchingCreditApp &&
            'message' in errorFetchingCreditApp &&
            errorFetchingCreditApp.message === 'no_credit_application_found') {
            const errMsg = API_ERROR_MAP.no_credit_application_found_one_time;
            reportError('flashError', {
                componentName: 'Wizard',
                funcName: 'useEffect',
                errType: 'api',
                errURL: window.location.pathname,
                errMsg: errMsg,
            }, errorFetchingCreditApp);
            toastError(errMsg);
            history.push(CREDIT_PORTAL_URL);
        }
    }, [
        prequalificationUrl,
        creditApplicationByTokenValidate,
        errorFetchingCreditApp,
        storeLinkCampaignMatches,
        isFetchingCampaignValidation,
        nativeApplicationEnabled,
    ]);
    useEffect(() => {
        if (prequalification?.applicationId) {
            setApplicationId(prequalification.applicationId);
        }
    }, [prequalification]);
    useEffect(() => {
        if (creditApplicationByTokenValidate) {
            dispatch(setPersonalInfo({
                ...creditApplicationByTokenValidate.applicant,
                // Preserve a phone entered in the Prove OTA flow that the on-file
                // applicant doesn't carry, so it survives this reload-time re-seed.
                // (setPersonalInfo replaces the slice, so an absent phone would wipe it.)
                primaryPhone: creditApplicationByTokenValidate.applicant?.primaryPhone ||
                    personalInfo?.primaryPhone,
            }));
            dispatch(setCreditApplication(creditApplicationByTokenValidate?.creditApplication));
            dispatch(setPractice(creditApplicationByTokenValidate.location));
        }
        // personalInfo is intentionally omitted from deps: it is read only as a
        // fallback, and including it would re-run this effect on every dispatch.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [creditApplicationByTokenValidate]);
    useEffect(() => {
        if (!location.state?.fromFindMyApp) {
            dispatch(setLenderName(''));
            // On an OTA deep-link the token seeds creditApplication (effect above);
            // don't null it here or this mount clear races and wipes the rehydration.
            if (!tokenRef.current) {
                dispatch(setCreditApplication(null));
            }
        }
    }, []);
    if (isFetchingOTAToken ||
        !applicationEnvironment ||
        isLoadingPrequalNew ||
        isFetchingCampaignValidation ||
        (!isNil(prequalificationUrl) &&
            isNil(applicationId) &&
            !storeLinkCampaignMatches &&
            !nativeApplicationEnabled))
        return _jsx(Spinner, { centerPage: true });
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "wizard", children: [_jsxs("div", { className: "stepper-container", children: [_jsx(P, { className: "steppper-header", children: mobile_steps[state.step] }), _jsx(Stepper, { activeStep: state.step, alternativeLabel: true, connector: _jsx(FormConnector, {}), children: steps.map((label) => (_jsx(Step, { children: _jsx(StepLabel, { StepIconComponent: FormStepIcon, children: label }) }, label))) })] }), _jsx("div", { className: "content", children: getScreen })] }) }));
}
export default Wizard;
function FormStepIcon(props) {
    const useFormStepIconStyles = makeStyles({
        root: {
            color: INLINE_COLORS.greyLight,
            display: 'flex',
            width: 'auto',
            height: 22,
            alignItems: 'center',
        },
        active: {
            color: INLINE_COLORS.darkgreyBase,
        },
        circle: {
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: INLINE_COLORS.darkgreyBase,
            textAlign: 'center',
            padding: '5px',
        },
        activeCircle: {
            zIndex: 1,
            width: 25,
            height: 25,
            borderRadius: '50%',
            backgroundColor: INLINE_COLORS.redBase,
        },
        activeSubCircle: {
            zIndex: 2,
            width: 10,
            height: 10,
            borderRadius: '50%',
            backgroundColor: INLINE_COLORS.whiteBase,
            margin: '7.5px',
        },
        completed: {
            color: INLINE_COLORS.whiteBase,
            zIndex: 1,
            fontSize: 18,
            padding: '3px',
        },
        completedDiv: {
            backgroundColor: INLINE_COLORS.redBase,
            height: 25,
            width: 25,
            borderRadius: '50%',
        },
    });
    const classes = useFormStepIconStyles();
    const { active, completed } = props;
    return (_jsx("div", { className: clsx(classes.root, {
            [classes.active]: active,
        }), children: completed ? (_jsx("div", { className: classes.completedDiv, children: _jsx(DoneIcon, { className: classes.completed }) })) : (_jsxs("div", { className: active ? classes.activeCircle : classes.circle, children: [active ? _jsx("div", { className: classes.activeSubCircle }) : _jsx("div", {}), ' '] })) }));
}
